import {getColor} from "@/styles/ThemeConfig";
import Image from "next/image";
import Link from "next/link";
import styled from "styled-components";
import {breakpoints} from "@/styles/sizes";
import ForceSSRLink from "@/components/other/ForceSSRLink";

const SocialLink = styled(ForceSSRLink)`
    width: 40px;
    height: 40px;
    
    display: flex;
    justify-content:center;
    align-items:center;
    transition: 0.3s ease;
    
    :hover{
        background-color: rgba(0,0,0,0.5);
    }
`
const FooterLink = styled(ForceSSRLink)`
    color:${getColor('gold')}; 
    text-decoration: none;
    white-space:nowrap;
    
    :hover{
        .text{
            white-space: nowrap;
            text-decoration: underline;
        }
    }
`

const Wrapper = styled.div`
    background: ${getColor('green')};
    color: white;
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
    justify-content: center;
    padding: 50px;
    overflow: hidden;
    @media only screen and (${breakpoints.mobile}) {
        padding: 50px 20px;
    }
`;

export default function Footer({footerData,socialLinks})
{

    return <Wrapper>
        <Image
            width={56}
            height={56}
            src={footerData?.logo?.url}
            alt={footerData?.logo?.alt ?? footerData?.logo?.name}
            style={{
                width: '56px',
                height: 'auto',
            }}
        />


        <div style={{textAlign:'center'}}>
            <div style={{fontSize:'26px', textTransform:'uppercase', marginBottom:'5px'}}>{footerData?.data?.title}</div>
            <div style={{fontSize:'24px',fontWeight:'bold', textTransform:'uppercase'}}>{footerData?.data?.subtitle}</div>
        </div>


        <div>
            {footerData?.recommendationImages?.map((item, index) => {
                return <Image key={index} width={500} height={500} src={item?.url} alt={item?.alt ?? item?.name}
                              style={{
                                  width: 'auto',
                                  maxWidth:'100%',
                                  height: 'auto',
                              }}/>
            })}
        </div>

        <div style={{
            textAlign:'center',
        }}>
            <span style={{
                color:getColor('gold')
            }}>Essor Ltd. © 2024</span> - Secret Food Tours is a trading name and registered trademark of Essor ltd. Registered in England and Wales company no 8368703.
        </div>


        <div style={{
            color:getColor('gold'),
            marginBottom:'20px',
            textDecoration:'none',
            display:'flex',
            alignItems:'center',
            justifyContent:'center',
            gap:"10px",
            flexWrap: 'wrap',
        }}>
            <FooterLink prefetch={false} href={'/we-love-bloggers'}><span className={'text'}>We Love Bloggers</span></FooterLink>
            <span className={'line'}>|</span>
            <FooterLink prefetch={false} href={'https://www.secretfoodtours.com/blog'}><span className={'text'}>Blog</span></FooterLink>
            <span className={'line'}>|</span>
            <FooterLink prefetch={false} href={'/read-about-us'}><span className={'text'}>Read About Us</span></FooterLink>
            <span className={'line'}>|</span>
            <FooterLink prefetch={false} href={'/join-us'}><span className={'text'}>Join Us</span></FooterLink>
            <span className={'line'}>|</span>
            <FooterLink prefetch={false} href={'/world-tours'}><span className={'text'}>World Food Tours</span></FooterLink>
            <span className={'line'}>|</span>
            <FooterLink prefetch={false} href={'/terms-and-conditions'}><span className={'text'}>Terms and conditions</span></FooterLink>
            <span className={'line'}>|</span>
            <FooterLink prefetch={false} href={'/private-bookings'}><span className={'text'}>Group & Private Tours</span></FooterLink>
            <span className={'line'}>|</span>
            <FooterLink prefetch={false} href={`mailto:${footerData?.data?.email}`}><span className={'text'}>Contact Us</span></FooterLink>
            <span className={'line'}>|</span>
            <FooterLink prefetch={false} href={`https://maps.app.goo.gl/NTcq2offhBvzP8pf8`} target={'_blank'}><span className={'text'}>Mail/Post Us</span></FooterLink>
        </div>

        <div style={{
            display:'flex',
            alignItems:'center',
            justifyContent:'center',
            gap:'10px',
            marginBottom:'20px',
        }}>
            {socialLinks?.map((item, index) => {
                return <SocialLink
                    key={index}
                    style={{
                    }}
                    href={item?.url}
                    target={'_blank'}
                >
                    <Image key={index} width={25} height={25} src={item?.image?.url}
                           alt={item?.image?.alt ?? item?.image?.name}
                           style={{
                               width: 'auto',
                               height: 'auto',
                           }}/>
                </SocialLink>

            })}
        </div>

        <div dangerouslySetInnerHTML={{__html: footerData?.data?.form}}/>

        <div style={{
            marginTop:'60px',
            fontSize:'24px',
            fontFamily:'Playfair Display',
        }}>{footerData?.data?.proudMembersTitle}</div>

        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '30px'
        }}>
            {footerData?.proudMembersImages?.map((item, index) => {
                return <Image key={index} width={300} height={26} src={item?.url} alt={item?.alt ?? item?.name}
                              style={{
                                  width: 'auto',
                                  height: '26px',
                              }}/>
            })}
        </div>
    </Wrapper>
}
